import { useMemo } from 'react';
import {
    type AppointmentModuleInDealerSpecsFragment,
    type ConfiguratorModuleInDealerSpecsFragment,
    type DealerFragmentFragment,
    type EventApplicationModuleInDealerSpecsFragment,
    type FinderApplicationPrivateModuleInDealerSpecsFragment,
    type FinderApplicationPublicModuleInDealerSpecsFragment,
    type GiftVoucherModuleInDealerSpecsFragment,
    type StandardApplicationModuleInDealerSpecsFragment,
} from '../../../api/fragments';
import { ModuleType } from '../../../api/types';

export type ApplicationModulesType =
    | StandardApplicationModuleInDealerSpecsFragment
    | EventApplicationModuleInDealerSpecsFragment
    | ConfiguratorModuleInDealerSpecsFragment
    | FinderApplicationPrivateModuleInDealerSpecsFragment
    | FinderApplicationPublicModuleInDealerSpecsFragment
    | AppointmentModuleInDealerSpecsFragment
    | GiftVoucherModuleInDealerSpecsFragment;

const useDealerModules = (dealer: DealerFragmentFragment) =>
    useMemo(() => {
        if (!dealer.modulesInDealer.length) {
            return [];
        }

        return [
            // standardApplicationModules
            ...dealer.modulesInDealer.find(
                module => module.moduleType === ModuleType.StandardApplicationModule && module.items
            ).items,

            // eventApplicationModules
            ...dealer.modulesInDealer.find(
                module => module.moduleType === ModuleType.EventApplicationModule && module.items
            ).items,

            // configuratorModules
            ...dealer.modulesInDealer.find(
                module => module.moduleType === ModuleType.ConfiguratorModule && module.items
            ).items,

            // finderApplicationPublicModules
            ...dealer.modulesInDealer.find(
                module => module.moduleType === ModuleType.FinderApplicationPublicModule && module.items
            ).items,

            // finderApplicationPrivateModules
            ...dealer.modulesInDealer.find(
                module => module.moduleType === ModuleType.FinderApplicationPrivateModule && module.items
            ).items,

            // mobilityModules
            ...dealer.modulesInDealer.find(module => module.moduleType === ModuleType.MobilityModule && module.items)
                .items,

            // appointmentModules
            ...dealer.modulesInDealer.find(module => module.moduleType === ModuleType.AppointmentModule && module.items)
                .items,

            // giftVoucherModules
            ...dealer.modulesInDealer.find(module => module.moduleType === ModuleType.GiftVoucherModule && module.items)
                .items,
        ] as unknown as ApplicationModulesType[];
    }, [dealer]);

export default useDealerModules;
